import { useMiniCartInfo } from '@/context/mini-cart';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

/**
 * Routes to hide the mini cart on.
 */
const DENIED_MINI_CART_ROUTES = ['/checkout'];

export const useCartTrigger = props => {
  const {
    queries: { getItemCountQuery },
  } = props;

  const pathname = usePathname();

  const [isHidden, setIsHidden] = useState(() => DENIED_MINI_CART_ROUTES.includes(pathname));
  const { count: itemCount } = useMiniCartInfo();

  useEffect(() => {
    setIsHidden(DENIED_MINI_CART_ROUTES.includes(location.pathname));
  }, [pathname]);

  return {
    itemCount,
    hideCartTrigger: isHidden,
  };
};
